import { createAction, props } from '@ngrx/store';
import { Load } from '../models/load.model';

// Load Loads
export const loadLoads = createAction('[Spots->Loads] Load Loads', props<{ organizationId: string, date?: string }>());
export const loadLoadsSuccess = createAction('[Spots->Loads] Load Loads Success', props<{ loads: Load[] }>());

// Load Load by ID
export const loadLoad = createAction('[Spots->Loads] Load Load', props<{ organizationId: string, loadId: string }>());
export const loadLoadSuccess = createAction('[Spots->Loads] Load Load Success', props<{ load: Load }>());
export const clearSelectedLoad = createAction('[Spots->Loads] Clear Selected Load');

// Add Load
export const addLoad = createAction('[Spots->Loads] Add Load', props<{ organizationId: string, load: Load }>());
export const addLoadSuccess = createAction('[Spots->Loads] Add Load Success', props<{ load: Load }>());

// Add Loads in bulk
export const addLoadsBulk = createAction('[Spots->Loads] Add Loads Bulk', props<{ organizationId: string, loads: Load[] }>());
export const addLoadsBulkSuccess = createAction('[Spots->Loads] Add Loads Bulk Success', props<{ loads: Load[] }>());

// Update Load
export const updateLoad = createAction('[Spots->Loads] Update Load', props<{ organizationId: string, loadId: string, load: Partial<Load> }>());
export const updateLoadSuccess = createAction('[Spots->Loads] Update Load Success', props<{ load: Load }>());

// Delete Load
export const deleteLoad = createAction('[Spots->Loads] Delete Load', props<{ organizationId: string, loadId: string }>());
export const deleteLoadSuccess = createAction('[Spots->Loads] Delete Load Success', props<{ loadId: string }>());
